import { type ObjectDataShape } from '@capsicum/socios-core';
import { useMemo } from 'react';

import { parseImageFromFeedObject } from '../util';

export const useBannerObject = (object?: ObjectDataShape) => {
	return useMemo(
		() => ({
			image: parseImageFromFeedObject(object),
			isLinkDataObjectMalformed: !object?.link?.path ?? false
		}),
		[object]
	);
};
